import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=839d7788&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.vue?vue&type=style&index=0&id=839d7788&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports